export default function ({ app, route, redirect }) {
  const hasAuthToken = app.$cookies.get('apollo-token')

  if (!hasAuthToken) {
    redirect(app.localePath(`/auth/login?pathBefore=${route.fullPath}`))
  }
}
